import { render, staticRenderFns } from "./Simulate.vue?vue&type=template&id=d8034ca0&"
import script from "./Simulate.vue?vue&type=script&lang=js&"
export * from "./Simulate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports